import { styled } from '@mui/material/styles';

export const StyledInputRoot = styled('div')(({ theme }) => ({
    fontFamily: theme.fonts.default,
    color: theme.colors["neutral.50"],
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: "4px",
    border: 'none',
    boxShadow: 'none',
    overflow: "hidden",

    [`&.Mui-error input`]: {
        border: `1px solid ${theme.colors['red.500']}`
    },
    [`&.Mui-focused input`]: {
        border: `1px solid ${theme.colors['blue.500']}`
    },
}));

export const StyledInput = styled('input')(({ theme }) => ({
    fontFamily: theme.fonts.default,
    fontSize: theme.fontSizes.lg,
    lineHeight: theme.lineHeights.base,
    color: theme.colors["neutral.50"],
    border: 'none',
    boxShadow: 'none',
    background: 'none',
    padding: '8px 8px',
    width: theme.space._700,
    height: theme.space._600,
    textAlign: 'center',

    "&:focus-visible": {
      outline: 0,
    }
}));


export const StyledButton = styled('button')(({ theme }) => ({
    lineHeight: theme.lineHeights.base,
    width: theme.space._500,
    height: theme.space._600,
    display: 'none',
    flexFlow: 'row nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    transitionProperty: 'all',
    transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
    transitionDuration: '120ms',
    background: theme.colors['neutral.800'],
    border: `1px solid ${theme.colors['neutral.800']}`,

    "&:hover": {
        cursor: 'pointer',
        color: theme.colors['lime.500']
    },

   " &:focus-visible": {
        outline: 0
    },

    "&.increment": {
        order: 1
    }
}));